<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">To my fabulous support network.</p>
<p class="p2">You know who you are.</p>
<p class="p2">You provide daily encouragement and motivation and lots of laughs.</p>
<p class="p2">Thank you for making me smile.</p>
<p class="p2"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?6334a4d4